import Image from 'next/image';
import { appDownloadLinks } from './constants';
function DownloadApps() {
  return <div className='grid grid-cols-2 gap-x-4 gap-y-2' data-sentry-component="DownloadApps" data-sentry-source-file="download-apps.tsx">
            {appDownloadLinks.map(({
      title,
      url,
      imageUrl
    }) => !!url && <a href={url} target='_blank' rel='nofollow noreferrer' key={url}>
                            <Image unoptimized src={imageUrl} width={166} height={50} alt={title} className='min-w-[156px] rounded border border-[#9E9E9E]' />
                        </a>)}
        </div>;
}
export default DownloadApps;